module.exports = __webpack_public_path__ + "static/media/publish_01.e4435629.png";